<template>
  <p class="description"
     v-if="item.doc_descricao?.length > 0"
     v-html="item.doc_descricao"></p>
  <a v-for="it in item.doc_ficheiros" 
    :key="it.doc_ficheiros_url"
    :href="it.doc_ficheiros_url" 
    class="revistaentry"
    target="_blank">
      <img class="pdf_icon" :src="getDocumentIcon(it.extensao)">
      {{ it.doc_ficheiros_nome }}
  </a>
</template>

<script>
import pdf from "@/assets/icons/icon_pdf_cinza.png";
import word from "@/assets/icons/icons-05.png";
import officeForm from "@/assets/icons/icons-06.png";
import excel from "@/assets/icons/icons-07.png";

export default {
  props:["item"],
  setup() {

    const documentIcons = {
      pdf,
      excel,
      word,
      officeForm,
    };

    const getDocumentIcon = doctype => {
      return documentIcons[doctype] || pdf;
    };

    return {
      getDocumentIcon
    }
  }
}
</script>

<style lang="scss" scoped>
img{
    width: 30px;
    height:auto;
    margin-right: 15px;
}

a{
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #707475;
  font-family: "Montserrat Semibold";
  font-size: 15px;
}

p.description{
  margin-bottom: 40px;
  margin-top: 40px;
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}

p.description:deep(p){
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}

@media (max-width: 767px) {
  p.description,
  p.description:deep(p){
    padding-left: 0;
  }

  p.description:deep(p) {
    font-size: 14px;
    line-height: 1.9;
  }
}

</style>